/**
 * Different types of combiners (operators) in a DSL expression
 */
const COMBINER_TYPES = {
  AND: 1,
  OR: 2
};

module.exports = COMBINER_TYPES;



// WEBPACK FOOTER //
// ./src/js/constants/DSLCombinerTypes.js